import React from 'react';
import Img from 'gatsby-image';
import './index.scss';

const IndexPage = ({ data }) => {
  console.log(data);
  return (
    <div className="HomePage">
      <div className="wrapper">
        <Img sizes={data.file.childImageSharp.sizes} />
        <div className="photo-label">The Dirty Guv'nahs</div>
      </div>
    </div>
  );
};

export default IndexPage;

export const query = graphql`
  query IndexPage {
    file(relativePath: { eq: "tdg-banner.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 900, maxHeight: 450) {
          ...GatsbyImageSharpSizes
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js